<div class="row justify-content-center" [hidden]="!isloaderVisible">
  <div class="col-12">
    <div class="card">
      <div class="d-flex align-items-center justify-content-center" style="height: 110px">
        <div class="loading"></div>
      </div>
    </div>
  </div>
</div>
@if (!isloaderVisible) {
  <div class="row justify-content-center">
    <div class="col-12">
      @if (errorOccured === false) {
        <div class="card">
          @for (item of roadmapsData; track item) {
            <div>
              <div class="card-body" style="padding: 2px">
                @if (item.roadmapUrl !== '') {
                  <div class="wre-gateway-web-roadmaps-padding">
                    @if (item.roadmapUrl !== '') {
                      <div class="justify-content-center wrap-element">
                        <iframe
                          [src]="item.roadmapUrl | sanitizeUrl"
                          scrolling="yes"
                          frameborder="0"
                          target="_parent"></iframe>
                      </div>
                    }
                  </div>
                }
                @if (item.roadmapUrl === '') {
                  <div>
                    <p style="font-size: 1.1rem">Coming Soon</p>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (errorOccured === true) {
        <div class="card pt-3 pb-3 ps-3 pe-3">
          <wre-not-available
            serviceName="Roadmaps"
            [errorOccured]="errorOccured"></wre-not-available>
        </div>
      }
    </div>
  </div>
}
